import router from './router'
export const commonMixin = {	
	methods: {
		async updateIdconnects() {
			console.log('updateIdconnects');
			await this.LoadDBListFromServer()
			this.state.openedtabs.forEach(el => {
			  this.createIdconnect(el)
			})
		  },
		createIdconnect(tab) {						
			if (!tab.idconnect) {				
				let idconnect
				// console.log('createIdconnect 1');
				axios.post(this.baseUrl + "/api3", {cmd:11,guid:this.state.guid,token:this.state.token}).then(response => {					
					if (response.data.err === 301) {
						this.ShowAlert(`Administrative server restarted`)			
						this.updateIdconnects()
					} else if (response.data.err) {          
						this.ShowAlert(response.data.msg)
						console.log('createIdconnect resp', response.data.err);
						if (response.data.err == 401) {
							sessionStorage.removeItem("authToken")
							router.push('/login');
						}
					} else {
						// console.log('createIdconnect else');
						tab.idconnect = response.data.idconnect  
						// console.log('createIdconnect',tab.idconnect);
					}
				}).catch((error) => {
					// console.log('closeIdconnectErr',error.message);
				})  
			}
		},
		closeIdconnect(tab) {
			let nums = [tab.idconnect]
			axios.post(this.baseUrl + "/api3", {cmd:14,nums,guid:this.state.guid,token:this.state.token}).then(response => {
				console.log('closeIdconnect',response); // => the response payload 
				if (response.data.err == 401) {
					sessionStorage.removeItem("authToken")
					router.push('/login');
				}
			}).catch((error) => {
				console.log('closeIdconnectErr',error.message);
			})  
		},
		ShowAlert(msg) {
			console.log('mixin ShowAlert',this, msg);
			this.$confirm({
				message: msg,
				button: {
					yes: "Ok"
				}
			});
		},
		//add param idconnect
		ExecCommand(cmd, after, db, sql, idconnect, guid) {
			// console.log("ExecCommand");
			let data =  { cmd: cmd, idconnect: idconnect, guid: guid, token:this.state.token };
			if (cmd !== 7) {
			// if (cmd !== 65) {
				if (!db) {
					console.log("ExecCommand if db", db);
					if (cmd) {
						this.ShowAlert("Select database first");
					}
					return;
				}
				data.port = db.port;
				data.sql = sql;				
			}
			this.loading = true
			// console.log("ExecCommand",typeof(data));
			// const headers = {'Content-Type': 'application/x-www-form-urlencoded'}
			// const headers = {'Content-Type': 'application/json'}
			// {headers: headers}
			// "{\"cmd\":65}"
			// axios.post(this.baseUrl + "/jsonapi", data)
			
			axios.post(this.baseUrl + "/api3", data).then(response => {
				if (
					response.data.data &&
					response.data.data.length > 0 &&
					response.data.data[0].err
				) {
				} else {					
				}
				if (response.data.err === 301) {
					this.ShowAlert(`Administrative server restarted`)	
					this.updateIdconnects()				
				}
				if (response.data.err == 401) {
					sessionStorage.removeItem("authToken")
					router.push('/login');
				}
				
				if (after) {
					let start= Date.now()
					after(response)
					// console.log('TIME ',Date.now() - start);					
				};
				this.loading = false
				// console.log("ExecCommand",this.state.openedtabs[sessionStorage.getItem('active')]);	
				// this.OpenTab(this.state.openedtabs[sessionStorage.getItem('active')])
			}).catch((error) => {
				console.log('closeIdconnectErr',error.message);
				this.loading = false
				if (this.state && this.state.active_tab) {
					this.state.active_tab.error = []
					this.$set(this.state.active_tab, 'error', ["The connection is lost. Try running the query again or contact your administrator."])
				}
				this.ShowAlert("The connection is lost. Try running the query again or contact your administrator.")	
				// tab.status = ''
				// tab.result = ''
				// this.ShowAlert(error.message)
			});
		},
		//add param idconnect
		async ExecScript(db, sql, after, showalert = true, idconnect, guid ) {
			console.log('ExecScript', db);			
			if (!db) {
				console.log('ExecScript if db', db);			
				this.ShowAlert("Select database first");
				return;
			}
			let updateafterquery = false;
			let lowersql = sql.toLowerCase();
			if (
				lowersql.indexOf("create table") > -1 ||
				lowersql.indexOf("alter") > -1 ||
				lowersql.indexOf("drop table") > -1 ||
				lowersql.indexOf("create index") > -1
			) {
				console.log('Ex IndexOf');
				updateafterquery = true;
			}
			let theport = db.port;
			this.loading = true
			// this.state.queryNumber++
			axios
				.post(this.baseUrl + "/api3", {
				// .post("/api3", {
					cmd: 15,
					port: theport,
					sql: sql,
					idconnect: idconnect,
					guid: guid,
					token:this.state.token,
					queryNumber: this.state.queryNumber,
					// signal: this.state.controller.signal
				}, 
				// {cancelToken: axiosSource.token,}	
				)
				.then(response => {
					if (response.data && response.data[0] && this.state.queryNumber != response.data[0].queryNumber) {
						console.log("RunActiveTabWrongNumber", this.loading);
						// clearInterval(intervalRef);
						// tab.status = 'Request stopped' + (tab.result ? ', rows: ' + count : '');
						this.loading = false						
						return
					}
					let mesErr = "";
					if (mesErr !== "") {
						// this.ShowAlert(`Error: ${mesErr}`);
					}
					console.log('response',response);
					if (response.data.err === 301) {
						this.ShowAlert(`Administrative server restarted`)	
						this.updateIdconnects()				
					}
					if (response.data.err == 401) {
						sessionStorage.removeItem("authToken")
						router.push('/login');
					}
					if (after) {
						after(response)
					};
					if (updateafterquery != this.LoadDbFromServer)
						console.log('Ex upd',updateafterquery);
						// this.LoadDbFromServer(db);
				}).catch((error) => {
					console.log('ExecScript',error.message);
					this.loading = false
					// if (this.state && this.state.active_tab) {
					// 	this.state.active_tab.error = []
					// 	this.$set(this.state.active_tab, 'error', ["The connection is lost. Try running the query again or contact your administrator."])
					// }						
					this.ShowAlert("The connection is lost. Try running the query again or contact your administrator.")	
				}); ;
		},
		GetTables(db, type,num) {
			console.log('GetTables',num);
			var tables = [];
			if (db && db.data) {
				for (let i = 0; i < db.data.length; i++) {
					const tbl = db.data[i];
					if (tbl.type === type) tables.push(tbl);
				}
			}
			tables.sort((a,b) => {
				if (a.tablename < b.tablename) return -1;
				if (a.tablename > b.tablename) return 1;
			})
			// }).slice(0, 10)
			// console.log('GetT',t);
			// return tables;
			return tables;
		},
		GetTablesVirtual(db,type) {
			// console.log('GetTablesVirtual',db, type);
			let tbl
			if (db && db.data) {
				tbl = db.data.filter(i => i.type == type)				
			}
			// console.log('GetTablesVirtual',tbl);
			return tbl
		},
		LoadDbFromServer(db, after, getarr) {
			console.log('LoadDbFromServer', db);	
			window.start = Date.now();
			
			this.ExecCommand(
				8,
				response => {	
					if (response.data.err == '104') {
						console.log('LoadDbFromServer response', response.data);
						let msg = `${db.dbname} Err ${response.data.err}: ${response.data.msg}`;
						this.ShowAlert(msg);
						return;
					}

					function alphanum(a, b) {
						function chunkify(t) {
						  var tz = [], x = 0, y = -1, n = 0, i, j;
					  
						  while (i = (j = t.charAt(x++)).charCodeAt(0)) {
							var m = (i == 46 || (i >=48 && i <= 57));
							if (m !== n) {
							  tz[++y] = "";
							  n = m;
							}
							tz[y] += j;
						  }
						  return tz;
						}
					  
						var aa = chunkify(a);
						var bb = chunkify(b);
						// console.log('alphanum',x);
						for (let x = 0; aa[x] && bb[x]; x++) {
						  if (aa[x] !== bb[x]) {
							var c = Number(aa[x]), d = Number(bb[x]);
							if (c == aa[x] && d == bb[x]) {
							  return c - d;
							} else return (aa[x] > bb[x]) ? 1 : -1;
						  }
						}
						return aa.length - bb.length;
					}

					// Сортировка таблиц
					if (response.data.data) {
						response.data.data.sort(function (a, b) {
							return alphanum(a.tablename, b.tablename);
						});
					}

					let dbFromDblist = this.state.dblist.find(el => el.port === db.port);
					
					// Обновляем данные БД
					this.$set(dbFromDblist, "loaded", true);
					this.$set(dbFromDblist, "data", response.data.data);
					this.$set(dbFromDblist, "indexes", response.data.indexes);
					this.$set(dbFromDblist, "version", response.data.version);

					// Строим оптимизированную структуру меню
					this.buildOptimizedMenuStructure(db, response.data);
					
					// ОДИН РАЗ обновляем отображение
					this.$nextTick(() => {
						console.log(this);
						
						if (this.getArr) {
							console.log('LoadDbFromServer 1');
							
							this.getArr()
							// leftMenu.methods.getArr()
						} else {
							if (this.$refs.leftMenu) {
								console.log('LoadDbFromServer 2');
								this.$refs.leftMenu.getArr()								
							} else {
								console.log('LoadDbFromServer 3');
								console.log(this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$refs.leftMenu.getArr);

								this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$refs.leftMenu.getArr()								
							}
						}
					});
					
					if (after) after(response);
				},
				db,
				'',
				this.state.idconnect,
				this.state.guid,
				this.state.token
			);
		},
		// НОВЫЙ МЕТОД - оптимизированное построение структуры
		buildOptimizedMenuStructure(db, responseData) {
			const dbMenu = this.state.menuList2.find(elem => elem.port == db.port);
			if (!dbMenu) return;

			const tablesNode = {
				y: 1,
				name: 'Tables',
				type: 'lvl2',
				expanded: false,
				choseEl: false,
				expandedY: responseData.data.length + 1,
				id: db.port + '_tables',
				childs: [],
				parentId: db.port, // вместо parent ссылки
				parentType: 'lvl1'
			};

			// Создаем таблицы
			responseData.data.forEach((tableData, i) => {
				const tableNode = {
					y: 1,
					name: tableData.tablename,
					type: 'lvl3',
					expanded: false,
					choseEl: false,
					expandedY: 3,
					ind: i,
					childs: [],
					id: db.port + '_' + tableData.tablename,
					parentId: db.port + '_tables',
					parentType: 'lvl2',
					tableData: tableData // сохраняем исходные данные
				};

				// Колонки
				const columnsNode = {
					y: 1,
					name: 'Columns',
					type: 'lvl4',
					expanded: false,
					choseEl: false,
					expandedY: tableData.fields.length + 1,
					childs: [],
					id: db.port + '_' + tableData.tablename + '_columns',
					parentId: db.port + '_' + tableData.tablename,
					parentType: 'lvl3'
				};

				tableData.fields.forEach(field => {
					columnsNode.childs.push({
						y: 1,
						expandedY: 1,
						expanded: false,
						choseEl: false,
						name: field.name,
						type: 'lvl5',
						fld: field,
						parentId: db.port + '_' + tableData.tablename + '_columns',
						parentType: 'lvl4'
					});
				});

				// Индексы
				const indicesNode = {
					y: 1,
					name: 'Indices',
					type: 'lvl4',
					expanded: false,
					choseEl: false,
					expandedY: 1, // начнем с 1, увеличим при добавлении индексов
					childs: [],
					id:  db.port + '_' + tableData.tablename + '_indices',
					parentId: db.port + '_' + tableData.tablename,
					parentType: 'lvl3'
				};

				tableNode.childs.push(columnsNode, indicesNode);
				tablesNode.childs.push(tableNode);
			});

			// Добавляем индексы
			responseData.indexes.forEach(index => {
				const tableNode = tablesNode.childs.find(tbl => tbl.name === index.table);
				if (tableNode && tableNode.childs[1]) {
					const indicesNode = tableNode.childs[1];
					indicesNode.expandedY++;
					
					indicesNode.childs.push({
						y: 1,
						name: index.name,
						type: 'lvl5',
						expanded: false,
						choseEl: false,
						expandedY: index.fields.length + 1,
						childs: index.fields.map(fieldName => ({ 
							name: fieldName,
							type: 'lvl6',
							parentId: db.port + '_' + index.table + '_' + index.name,
							parentType: 'lvl5'
						})),
						id: db.port + '_' + index.table + '_' + index.name,
						parentId: db.port + '_' + index.table + '_indices',
						parentType: 'lvl4'
					});
				}
			});

			// Обновляем структуру меню
			dbMenu.childs = [tablesNode];
			dbMenu.expandedY = tablesNode.expandedY + 1;
			
			// Обновляем версию
			this.state.version = responseData.version;
		},			

		RunActiveTab() {
			console.log('RunActiveTab');
			this.showCancel = true
			let tab = this.state.active_tab;
			tab.result = ''	
			tab.status = "running";
			var queyString = tab.query;
			// console.log(tab);
			var lfcrRegexp = /\n\r?|\/n\/r?/g
			var query = queyString.replace(lfcrRegexp, "\r\n")
			if (this.state.active_tab.editor) {					
				let selectedtext = this.state.active_tab.editor.getSelectedText();
				if (selectedtext) {
					query = selectedtext;
				}
			}

			tab.error = [];
			tab.resultMulti = [];
			if (!this.state.active_db) {
				this.ShowAlert("Select database first");
				return;
			}
			let updateafterquery = false;
			let lowersql = query.toLowerCase();
			if (
				lowersql.indexOf("create table") > -1 ||
				lowersql.indexOf("alter") > -1 ||
				lowersql.indexOf("drop table") > -1 ||
				lowersql.indexOf("create index") > -1
			) {
				console.log('Ex IndexOf');
				updateafterquery = true;
			}
			let theport = this.state.active_db.port;
			this.loading = true
			window.hostname.loading = true
			// console.log("RunActiveTab1",query);
			let response 
			this.state.queryNumber++
			axios.post(
				this.baseUrl + "/api3", {
					cmd: 15,
					port: theport,
					sql: query,
					idconnect: tab.idconnect,
					guid: this.state.guid,
					token: this.state.token,
					queryNumber: this.state.queryNumber,
					// signal: this.state.controller.signal
				}, 
			).then((resp) => {
				// console.log('RunActiveTab',resp);
				if (resp.data && resp.data[0] && this.state.queryNumber != resp.data[0].queryNumber) {
					tab.status = '';
					console.log("RunActiveTabWrongNumber", tab.status);
					clearInterval(intervalRef);
					this.loading = false						
					return
				}
				this.loading = false
				// console.log('RunResp', resp);
				if (resp.data.err == 301) {
					this.ShowAlert(`${resp.data.err}`)	
					this.updateIdconnects()	
				}
				if (resp.data.err == 401) {
					sessionStorage.removeItem("authToken")
					router.push('/login');
				}
				// return resp
				response = resp
				let msg
				if (response.data && response.data[0]) {					
					msg = response.data[0].msg
				}
				if (msg !== "") {
					tab.resultMulti = response.data
					this.loading = false
					// return
				}
				let countQuery = 0
				let time = 0
				let lastInd = response.data.length -1
				tab.resultMulti = response.data
				// let timeQuery = start - this.state.startQuery;
				this.state.startQuery = start;
				// clearInterval(this.state.startQuery)
				if (response.data.length == 0) {
					this.loading = false
					tab.status = 'Successfully finished';	
				}
				//console.log("RunActiveTab2", response);
				if (response.data && response.data[lastInd] && response.data[lastInd].ready == 0) {
					// console.log('2');
					
					this.loading = true
					window.hostname.loading = true
					const intervalRef = setInterval(() => axios.post(this.baseUrl + "/api3",{"cmd":16,"idconnect":tab.idconnect,guid:this.state.guid,token:this.state.token,queryNumber:this.state.queryNumber})
					// this.state.startQuery = setInterval(() => axios.post(this.baseUrl + "/api3",{"cmd":16,"idconnect":tab.idconnect,guid:this.state.guid,token:this.state.token})
						.then((resp)=>{
							if (resp.data && resp.data[0] && this.state.queryNumber != resp.data[0].queryNumber) {
								console.log("RunActiveTabstop", this.loading);
								clearInterval(intervalRef);
								// tab.status = 'Request stopped' + (tab.result ? ', rows: ' + count : '');
								this.loading = false						
								return
							}
							countQuery++
							if (response.data.err == 401) {
								sessionStorage.removeItem("authToken")
								router.push('/login');
							}
							let lastInd = response.data.length -1
							// console.log("cmd16",lastInd);
							
							if (resp.data[lastInd].ready == 1) {
								let count = 0
								// console.log('2.1',resp);
								tab.resultMulti = resp.data;
								response.data.forEach(el => {
									console.log('rowscount', el.rowscount);									
									if (el.rowscount) {
										count += el.rowscount								
									}
									if (el.rowsaffected) {
										count += el.rowsaffected								
									}
								});
								tab.result = count
								if(tab.status == "running") {
									tab.status = 'Successfully finished'
								}
								// tab.status = 'Successfully finished' + (tab.result ? ', rows: ' + count : '');	
								// console.log("cmd16");					
								// clearInterval(this.state.startQuery)
								clearInterval(intervalRef);
								this.loading = false
								window.hostname.loading = false																
							}
							tab.result = resp.data[lastInd].rowscount							
						}					
					).catch((error) => {
						console.log('RunActiveTabErr2',error.message);
						clearInterval(intervalRef);
						this.loading = false
						this.state.active_tab.error = []
						if (this.state && this.state.active_tab) {
							this.$set(this.state.active_tab, 'error', ["The connection is lost. Try running the query again or contact your administrator."])
						}
						tab.status = ''
						tab.result = ''
					}),500)					
				} else if (response.data && response.data[lastInd] && !response.data[lastInd].err && response.data[lastInd].ready == 1){
					// clearInterval(intervalRef)
					// console.log('1');	
					let count = 0				
					tab.resultMulti = response.data;
					let t0 = response.config.t0;
					let t1 = response.t1;
					time += t1 - t0
					response.data.forEach(el => {
						if (el.rowscount) {
							count += el.rowscount								
						}
						if (el.rowsaffected) {
							count += el.rowsaffected								
						}
					});
					console.log("run3");					
					tab.result = count
					tab.status = 'Successfully finished';
					this.state.startQuery = null
					// this.loading = false
				}	

			}).catch((error) => {
				console.log('RunActiveTabErr',error);
				this.loading = false
				this.state.active_tab.error = []
				if (this.state && this.state.active_tab) {
					this.$set(this.state.active_tab, 'error', ["The connection is lost. Try running the query again or contact your administrator."])
				}
				tab.status = ''
				tab.result = ''
				// this.state.active_tab.error.push("The connection is lost. Try running the query again or contact your administrator.")
				// console.log("15", this.state.active_tab, error);
        	})
		},
		// testError() {			
		// 	this.$set(this.state.active_tab, 'error', ["Test error message"])
		// },
		CheckNameIsValid(name) {
			if (!name) return false;
			let validletters =
				"abcdefghijklmnopqrstuvwxyz1234567890_ABCDEFGHIJKLMNOPQRSTUVWXYZ";
			for (let index = 0; index < name.length; index++) {
				const l = name[index];
				if (validletters.indexOf(l) == -1) return false;
			}
			return true;
		},
		GetAValue() {
			return this.state.a;
		},
		SaveActiveTab() {
			if (!this.state.active_tab) return;
			let filename = this.state.active_tab.name;
			if (filename.indexOf(".txt") < 0) filename += ".txt";
			this.SaveFile(filename, this.state.active_tab.query);
		},
		SaveFile(filename, content) {
			var pom = document.createElement("a");
			pom.setAttribute(
				"href",
				"data:text/plain;charset=utf-8," + encodeURIComponent(content)
			);
			pom.setAttribute("download", filename);
			pom.style.display = "none";
			document.body.appendChild(pom);
			pom.click();
			document.body.removeChild(pom);
		},		
		ResponseHandler(response) {			
			// debugger
			let countQuery = 0
			let tab = this.state.active_tab;
			let lastInd = response.data.length -1
			let time = 0
			this.loading = false
			// console.log('ResponseHandler,',response);
			function queryRep(baseUrl) {
				countQuery++
				axios.post(baseUrl + "/api3",{"cmd":16,"idconnect":tab.idconnect,guid:this.state.guid,token:this.state.token})
				.then((response) => {
					console.log('ResponseHandler,queryRep',response);
					if (response.data.err == 401) {
						sessionStorage.removeItem("authToken")
						router.push('/login');
					}
					let lastInd = response.data.length -1
					if (response.data[lastInd].ready == 1) {		
						tab.resultMulti = response.data;
						let t0 = response.config.t0;
						let t1 = response.t1;
						let count = 0
						response.data.forEach(el => {
							if (el.rowscount) {
								count += el.rowscount								
							}
						});
						time += t1 - t0
						console.log('Resphundler');
						
						tab.result = count
						tab.status = 'Successfully finished' + (tab.result ? ', rows: ' + count : '');
						// tab.status = 'Successfully finished in ' + (t1 - t0) + 'ms' + (tab.result ? ', rows: ' + count : '');
					} else if(!response.data[lastInd].err && response.data[lastInd].ready === 0) {
						// tab.resultMulti = response.data;
						if (countQuery === 1) {
							tab.resultMulti = response.data;
						}
						// console.log('resp', response.data);						
						tab.resultMulti = response.data;
						let t0 = response.config.t0;
						let t1 = response.t1;
						// let count= 0
						time += t1 - t0
						console.log('resp', 2, time);
						// tab.status = 'Successfully finished in ' + (t1 - t0) + 'ms' + (tab.result ? ', rows: ' + count : '');
						// console.log('tabRes',countQuery);
						// setTimeout(() => {
						// 	queryRep(baseUrl)
						// }, 500);
					} else {
						console.log('resp', 3);
						tab.resultMulti = response.data;
						tab.status = 'Error'
						// console.log('tabRes',countQuery);
						return
					}
				}).catch((error) => {
					console.log('ResponseHandlerErr',error.message);
				})
			}
			let type = response.data.filter(item => item.type == 1);
			console.log('ResponseHandler,',!!type.length);
			if (response.data[lastInd].ready == 1 && type.length === 0) {
				console.log('resp E', response.data);
				let count = 0
				tab.resultMulti = response.data;
				response.data.forEach(el => {
					if (el.rowscount) {
						count += el.rowscount								
					}
					if (el.rowsaffected) {
						count += el.rowsaffected								
					}
				});
				console.log('RespHundler2');				
				tab.result = count
				tab.status = 'Successfully finished' + (tab.result ? ', rows: ' + count : '');
			} else {
				queryRep(this.baseUrl)
			} 	
		},		
		dispatch(componentName, eventName, ...rest) {
			// console.log('dispatch', componentName, eventName);
			// console.log('dispatch2', this);

			let parent = this.$parent || this.$root
			let name = parent.$options.name
	  
			while (parent && (!name || name !== componentName)) {
			  parent = parent.$parent
			  if (parent) {
				name = parent.$options.name
			  }
			}
	  
			if (parent) {
			  parent.$emit.apply(parent, [eventName].concat(rest))
			}
		},	  
  },	
	data: () => ({
		// baseUrl: "http://127.0.0.1:8008",
		baseUrl: "",
		typemap: {
			"1-1": "varchar", //PK
			"1-0": "varchar",
			"1-2": "varchar", //FK
			"2-0": "int",
			"2-1": "int", //PK
			"2-2": "int", //FK
			"3-0": "bigint",
			"3-1": "bigint", //PK
			"3-2": "bigint", //FK
			"4-0": "double",
			"4-1": "double", //PK
			"4-2": "double", //FK
			"5-0": "datetime",
			"5-1": "datetime", //PK
			"5-2": "datetime", //FK
			"6-0": "bit",
			"7-0": "date",
			"7-1": "date", //PK
			"7-2": "date", //FK
			"9-0": "varbinary",
			"9-1": "binary", //PK
			"9-2": "varbinary", //FK
			"10-0": "nvarchar",
			"10-1": "nchar",
			"10-2": "nvarchar",
			"11-0": "rowversion",
			"11-1": "rowversion",
			"11-2": "rowversion",
			"12-0": "decimal",
			"12-1": "decimal",
			"12-2": "decimal",
		},
		typemap2: {
			"1": "varchar",
			"2": "int",
			"3": "bigint",
			"4": "double",
			"5": "datetime",
			"6": "bit",
			"7": "date",
			"9": "varbinary",
			"10": "nvarchar",
			"11": "rowversion",
			"12": "decimal",
		},
		typemap3: [
			{ id: "1", name: "varchar" },
			{ id: "2", name: "int" },
			{ id: "3", name: "bigint" },
			{ id: "4", name: "double" },
			{ id: "5", name: "datetime" },
			{ id: "6", name: "bit" },
			{ id: "7", name: "date" },
			{ id: "9", name: "varbinary" },
			{ id: "10", name: "nvarchar" },
			{ id: "11", name: "rowversion" },
			{ id: "12", name: "decimal" },
		],
		typemap4: [
			// { id: "1", name: "varchar" },
			{ id: "1-3", name: "bigint" }, 
			{ id: "2-9", name: "binary(50)" },
			{ id: "3-6", name: "bit" },
			{ id: "4-10", name: "char(10)" },
			{ id: "5-7", name: "date" },
			{ id: "6-5", name: "datetime" },
			{ id: "7-5", name: "datetime2(7)" },
			{ id: "8-12", name: "decimal(18, 0)" },
			{ id: "9-4", name: "double" },
			{ id: "10-2", name: "int" },
			{ id: "11-10", name: "nvarchar(50)" },
			{ id: "12-10", name: "nchar(10)"},
			{ id: "13-10", name: "nvarchar(MAX)" },
			{ id: "14-11", name: "rowversion" },
			{ id: "15-9", name: "varbinary(50)" },
			{ id: "16-9", name: "varbinary(MAX)" },
			{ id: "17-10", name: "varchar(50)" },
			{ id: "18-10", name: "varchar(MAX)" },
		],
		typemap5: [
			"bigint", 
			"binary(50)",
			"bit",
			"char(10)",
			"date",
			"datetime",
			"datetime2(7)",
			"decimal(18, 0)",
			"double",
			"int",
			"nvarchar(50)",
			"nchar(10)",
			"nvarchar(MAX)",
			"rowversion",
			"varbinary(50)",
			"varbinary(MAX)",
			"varchar(50)",
			"varchar(MAX)",
		]
	})
};
